import LaunchIcon from '@material-ui/icons/Launch';
import { createPlugin } from '@backstage/core-plugin-api';
import {
  createSearchResultListItemExtension,
  DefaultResultListItem,
  SearchResultListItemExtensionProps,
} from '@backstage/plugin-search-react';

export const QUICK_LINK_SEARCH_RESULT_TYPE = 'quick-link';

// Inner component — receives the already-dispatched result document.
// The predicate on the extension guarantees this only renders for quick-link results.
const QuickLinkSearchResultListItemInner = ({
  result,
  rank,
}: SearchResultListItemExtensionProps) => (
  <DefaultResultListItem result={result} rank={rank} icon={<LaunchIcon />} />
);

// A minimal plugin scoped to the quick-links feature provides the extension.
// `createSearchResultListItemExtension` registers a predicate used by
// Backstage's <SearchResult> to select the correct renderer per result type,
// so the LaunchIcon and source chip are applied only to 'quick-link' results.
const quickLinksPlugin = createPlugin({ id: 'quick-links' });

export const QuickLinkSearchResultListItem = quickLinksPlugin.provide(
  createSearchResultListItemExtension({
    name: 'QuickLinkSearchResultListItem',
    component: async () => QuickLinkSearchResultListItemInner,
    predicate: result => result.type === QUICK_LINK_SEARCH_RESULT_TYPE,
  }),
);
